export enum LocationType {
    Shop = 1,
    MobileOnly = 2,
    ManagedService = 3
}
